module.exports = __webpack_public_path__ + "static/media/source-sans-pro-regular.2da39ecf.ttf";